import { BASE_URL } from "@/constants/apiConfig";
import {
  serverSideNotFound,
  serverSideRedirect,
} from "@/utils/server/serverSide";
import { useInterval } from "ahooks";
import { Button } from "antd";
import fetch from "node-fetch";
import { useEffect, useState } from "react";
import HBEmpty from "../../components/HBEmpty";
import styles from "./index.module.less";

export default function Go({ data }) {
  const [count, setCount] = useState(3);

  useInterval(() => {
    if (count > 0) {
      setCount(count - 1);
    }
  }, 1000);

  useEffect(() => {
    if (count === 0) {
      window.location.href = data.link;
    }
  }, [count, data.link]);

  const onClick = () => {
    window.location.href = data.link;
  };

  return (
    <div className={styles.go}>
      <HBEmpty
        image="//cdn.dancf.com/fe-assets/img/d0b151198d23d55839eeddfeadcae09e.svg"
        title="你即将离开花瓣，跳转至其他页面"
        subtitle={
          <div className={styles.subtitle}>
            <span>{count}</span>
            秒后自动跳转
          </div>
        }
      />
      <div className={styles.button}>
        <Button type="primary" onClick={onClick}>
          立即跳转
        </Button>
      </div>
    </div>
  );
}

export async function getServerSideProps(props) {
  const { pin_id } = props.query;
  // 本地的话这块可能会报错，因为本地机器请求需要走https，不走会被301重定向，但是服务器上需要走http
  const result = await fetch(
    `${BASE_URL.replace("https", "http")}/go?pin_id=${pin_id}`,
    {
      redirect: "manual",
    }
  );

  if (result.status === 302) {
    return serverSideRedirect(props.res, {
      destination: encodeURI(result.url),
      permanent: false,
    });
  } else {
    const data = await result.json();
    if (data.err) {
      return serverSideNotFound(props.res);
    } else {
      return {
        props: {
          data,
        },
      };
    }
  }
}
